import React, { useMemo } from 'react'
import { Box, Button } from '@mui/material'
import { groupFilesByOwner } from './utility'
import { GDriveFile } from '../contentService/types'
import { Column } from 'shared/ui/Table/types'
import { Table } from 'shared/ui/Table/Table'
import { stringOrNumberSort } from '../Helpers'
import { downloadCsv } from '../../utility'

export function PresentationFileOwners({
  presentationFiles,
}: {
  presentationFiles: GDriveFile[]
}) {
  const { owners } = groupFilesByOwner(presentationFiles)
  const columns = useTableColumns(presentationFiles)

  return (
    <Box>
      <Box padding="20px">
        <Table
          title={
            <Box>
              <Box>Owners</Box>
              <Box>{`Total Files: ${presentationFiles.length}`}</Box>
            </Box>
          }
          columns={columns}
          items={Object.keys(owners).sort(stringOrNumberSort)}
        />
      </Box>
    </Box>
  )
}

function useTableColumns(presentationFiles: GDriveFile[]): Column<string>[] {
  return useMemo(() => {
    const { owners, ownerFiles } = groupFilesByOwner(presentationFiles)
    return [
      {
        title: 'Owner',
        rowContent: (email) => {
          const user = owners[email]
          return user.displayName
        },
      },
      {
        title: 'Email',
        rowContent: (email) => email,
      },
      {
        title: 'Count',
        rowContent: (email) => {
          const files = ownerFiles[email]
          return files.length
        },
      },
      {
        title: 'Export',
        rowContent: (email) => {
          const user = owners[email]
          const files = ownerFiles[email]
          return (
            <Button
              onClick={() => {
                downloadCsv(
                  `${user.displayName}-presentation-files`,
                  files.map(({ id }) => [id]),
                )
              }}
            >
              Export
            </Button>
          )
        },
      },
    ]
  }, [presentationFiles])
}
